import PropTypes from "prop-types";
import { useEffect } from "react";

import { Loader } from "@features/ui";

import {
  useBudgetPlan,
  useCreateBudgetPlan,
} from "@features/budgeting-game/api";
import { useCareerPlan } from "@features/career-details/api/use-career-plan";
import { useCreateCareerPlan } from "@features/career-details/api/use-create-career-plan";

import { useUserJourney } from "../api/use-user-journey";

import { StartOverConfirmationModal } from "@features/shared";

export const CareerPlanGuard = ({ onContinue, onReject }) => {
  const {
    data: { currentJourneyCareer },
  } = useUserJourney();

  const {
    data: { career },
  } = useCareerPlan();

  const { data: budgetPlan } = useBudgetPlan();

  const { mutateAsync: createBudgetPlan, isPending: creatingBudgetPlan } =
    useCreateBudgetPlan();

  const isSameCareer = currentJourneyCareer?.id === career?.id;

  const { mutateAsync: createCareerPlan, isPending: creatingCareerPlan } =
    useCreateCareerPlan(currentJourneyCareer?.transfrId);

  const activateNewCareerPlan = async () => {
    // First create a new budget plan if it doesn't exist
    // This can happen if user doesn't open the budget game sheet
    if (budgetPlan?.notFound) {
      await createBudgetPlan({
        transfr_id: currentJourneyCareer.transfrId,
      });
    }

    await createCareerPlan();
    onContinue();
  };

  const validateCurrentJourneyCareer = async () => {
    if (isSameCareer) {
      onContinue();
    } else if (!career) {
      activateNewCareerPlan();
    }
  };

  useEffect(() => {
    validateCurrentJourneyCareer();
  }, []);

  return (
    <>
      <StartOverConfirmationModal
        career={career}
        open={!isSameCareer && !!career}
        onClose={onReject}
        onConfirm={activateNewCareerPlan}
        onCancel={onReject}
        isNewCareer
        trackingPrefix="map-three"
      />
      <Loader show={creatingCareerPlan || creatingBudgetPlan}></Loader>
    </>
  );
};

CareerPlanGuard.displayName = "Replace Career Plan Guard";

CareerPlanGuard.propTypes = {
  onContinue: PropTypes.func,
  onReject: PropTypes.func,
};
